import { RcClasses } from '../../../../foundation';
export var RcTabPanelClasses = RcClasses([], 'RcTabPanel');
